export default __webpack_public_path__ + "static/default-w-chckup-f86c3b54122ac152e0fa7e4cc04cc74e.png";